import dayjs from 'dayjs';
import { PolicyHeaderDateFormat } from '../_types/manuals/draft';

/**
 * Formats a date value based on the specified format.
 * Handles parsing of backend date formats (MMDDYYYY and MMYYYY) and outputs formatted strings.
 *
 * @param dateValue - The date string to format (e.g., "01262026" or "012026")
 * @param dateFormat - The format type ('MMYYYY' or 'MMDDYYYY')
 * @returns Formatted date string
 */
export const formatDate = (dateValue: string, dateFormat?: string): string => {
  if (!dateValue) return '';

  // Parse based on the format parameter (trust the backend)
  const parseFormat = dateFormat === 'MMYYYY' ? 'MMYYYY' : 'MMDDYYYY';
  let date = dayjs(dateValue, parseFormat);

  if (!date.isValid() && dateValue.length === 6 && dateFormat === 'MMDDYYYY') {
    date = dayjs(dateValue, 'MMYYYY');
    if (date.isValid()) return date.format('MMMM YYYY');
  }

  if (!date.isValid()) return dateValue;

  // Format output based on dateFormat
  return dateFormat === 'MMYYYY'
    ? date.format('MMMM D, YYYY')  // Long format: "January 1, 2026"
    : date.format('MM/DD/YYYY');    // Short format: "01/26/2026"
};

/**
 * Formats a preview date for demonstration purposes.
 * Used in UI previews to show how dates will appear.
 *
 * @param format - The format type ('MMYYYY' or 'MMDDYYYY')
 * @returns Formatted current date string for preview
 */
export const formatDatePreview = (format?: PolicyHeaderDateFormat): string => {
  const now = dayjs();
  if (format === 'MMYYYY') {
    return now.format('MMMM D, YYYY');
  }
  return now.format('MM/DD/YYYY');
};
